import { SignInState, signInInitialState } from './State'

import {
  SET_EMAIL,
  SET_IS_SUBMITTING,
  SET_IS_VALID_EMAIL,
  SET_IS_VALID_PASSWORD,
  SET_PASSWORD,
  SET_ERROR,
  RESET,
  SET_IS_REQUEST_RESET_PASSWORD_DIALOG_OPEN,
  SET_IS_SENDING_RESET_PASSWORD_REQUEST,
  SET_REQUEST_RESET_PASSWORD_EMAIL,
  SET_IS_REQUEST_RESET_PASSWORD_EMAIL_VALID,
  SignInAction
} from './Actions'

function signInReducer(state: SignInState, action: SignInAction): SignInState {
  switch (action.type) {
    case SET_EMAIL:
      return Object.assign({}, state, { email: action.payload })
    case SET_IS_SUBMITTING:
      return Object.assign({}, state, { isSubmitting: action.payload })
    case SET_IS_VALID_EMAIL:
      return Object.assign({}, state, { isValidEmail: action.payload })
    case SET_IS_VALID_PASSWORD:
      return Object.assign({}, state, { isValidPassword: action.payload })
    case SET_PASSWORD:
      return Object.assign({}, state, { password: action.payload })
    case SET_ERROR:
      return Object.assign({}, state, { error: action.payload })
    case SET_IS_REQUEST_RESET_PASSWORD_DIALOG_OPEN:
      return Object.assign({}, state, { isRequestResetPasswordDialogOpen: action.payload })
    case SET_IS_SENDING_RESET_PASSWORD_REQUEST:
      return Object.assign({}, state, { isSendingResetPasswordRequest: action.payload })
    case SET_REQUEST_RESET_PASSWORD_EMAIL:
      return Object.assign({}, state, { requestResetPasswordEmail: action.payload })
    case SET_IS_REQUEST_RESET_PASSWORD_EMAIL_VALID:
      return Object.assign({}, state, { isRequestResetPasswordEmailValid: action.payload })
    case RESET:
      return Object.assign({}, signInInitialState)
    default:
      return state
  }
}

export default signInReducer
